import React, { useState } from 'react';
import { Box, FormControl, FormHelperText, FormLabel } from '@mui/material';
import { Control, useController, UseControllerProps } from 'react-hook-form';
import { Quill } from '../Quill/Quill';

interface IProps extends Omit<UseControllerProps, 'control'> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    control?: Control<any>;
    label?: string;
    disabled?: boolean;
    placeholder?: string;
    onChange?: (description: string | undefined | null) => void;
    maxLength?: number;
}

export const AppQuill = (props: IProps) => {
    const { fieldState, field } = useController({ ...props, defaultValue: props.defaultValue != null ? props.defaultValue : '' });
    const [remaining, setRemaining] = useState(props.maxLength ?? 0);

    const handleChange = (value: string) => {
        const normalized = value !== '<p><br></p>' ? value : null;
        field.onChange(normalized);
        props.onChange?.(normalized);
    };

    return (
        <FormControl fullWidth error={!!fieldState.error}>
            {props.label && (
                <FormLabel sx={{ fontSize: '0.875rem', display: 'block', mb: 0.5 }}>
                    {props.label}
                </FormLabel>
            )}
            <Quill
                initialContent={field.value ?? ''}
                handleChange={handleChange}
                maxLength={props.maxLength}
                setRemainingCharacters={props.maxLength !== undefined ? setRemaining : undefined}
                placeholder={props.placeholder}
                disabled={props.disabled}
            />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: '4px' }}>
                <FormHelperText sx={{ m: 0 }}>{fieldState.error?.message}</FormHelperText>
                {props.maxLength !== undefined && (
                    <FormHelperText sx={{ color: remaining < 0 ? 'error.main' : 'text.secondary', m: 0 }}>
                        {remaining} characters remaining
                    </FormHelperText>
                )}
            </Box>
        </FormControl>
    );
};
